import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { ImageAspectRatio } from '@beat-venues/common-types';
import { Text } from '../../';

export interface CoverEventProps
    extends CommonProps,
        VariantProps<typeof CoverEventStyles> {
    image: { url: string; alt: string; aspectRatio: ImageAspectRatio };
    attendanceBanner?: string;
}

export const CoverEventStyles = cva('rounded-lg');

export const CoverEvent = ({
    className,
    image,
    attendanceBanner,
    testId = 'cover-event',
    ...props
}: CoverEventProps): JSX.Element => {
    return (
        <div
            className={twMerge(CoverEventStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            <div className="transition hover:scale-105">
                <img src={image.url} alt={image.alt} />
            </div>
            {attendanceBanner && (
                <div className="absolute right-0 top-0">
                    <Text
                        size="xl"
                        className="bg-ba-accent absolute -right-10 top-10 w-[190px] rotate-45 transform whitespace-nowrap py-1 text-center font-semibold"
                    >
                        {attendanceBanner}
                    </Text>
                </div>
            )}
        </div>
    );
};
